export const PAGE_TITLES: { [key: string]: string } = {
  // Authentication
  '/login': 'Login',
  '/register': 'Register',
  '/forgot-password': 'Forgot Password',
  '/logout': 'Logout',
  '/user-profile': 'User Profile',
  
  // Dashboard
  '/dashboard': 'Dashboard',
  '/': 'Dashboard',
  
  // Weekly Reports
  '/WeeklyReports': 'Weekly Reports',
  '/WeeklyReports/detail': 'Weekly Report Details',
  
  // Banner Management
  '/banner-management': 'Banner Management',
  
  // Blog Details
  '/blog-details/categories': 'Blog Categories',
  '/blog-details/blogs': 'Blog Management',
  '/blog-details/blogs/add': 'Add Blog',
  '/blog-details/blogs/:id': 'Edit Blog',
  
  // News Articles
  '/news-articles': 'News Articles',
  '/news-articles/add': 'Add News Article',
  '/news-articles/:id': 'Edit News Article',
  
  // Tournament Details
  '/tournament-details': 'Tournament Details',
  '/tournament-details/overview': 'Tournament Overview',
  '/tournament-details/age-category': 'Age Categories',
  '/tournament-details/tournaments': 'Tournaments',
  '/tournament-details/:id': 'Tournament Details',
  
  // Tournaments
  '/tournaments': 'Tournaments',
  '/tournaments/:id': 'Tournament Details',
  '/tournaments/:id/register': 'Team Registration',
  '/tournaments/:id/teams/:teamId/players': 'Player Management',
  '/tournaments/:id/teams/:teamId/payments': 'Payment Management',
  '/tournaments/:id/payment': 'Payment',
  '/tournaments/registered/:id': 'Registered Tournament',
  
  // My Club
  '/my-club': 'My Club',
  '/my-club/team-information': 'Team Information',
  '/my-club/team-information/:teamId': 'Team Details',
  '/my-club/team-information/:teamId/players': 'Team Players',
  '/my-club/player-information': 'Player Information',
  '/my-club/player-information/add': 'Add Player',
  '/my-club/player-information/:playerId': 'Player Details',
  '/my-club/club-information': 'Club Information',
  
  // Manage Tournaments (legacy) and Tournaments listing (new)
  '/sports-management': 'Sports Management',
  '/manage-tournaments': 'Tournaments listing',
  '/manage-tournaments/:id': 'Tournament Details',
  '/tournaments-listing': 'Tournaments listing',
  '/tournaments-listing/:id': 'Tournament Details',
  '/tournaments-listing/add': 'Add New Tournament',
  '/manage-tournaments/add': 'Add New Tournament',
  
  // Registered Tournaments
  '/registered-tournaments': 'Tournament Team Registrations',
  '/registered-tournaments/:id': 'Registered Tournament Detail',
  
  // Payment & Transactions
  '/payment-transactions': 'Payment Transactions',
  '/payment-transactions/dues': 'Dues Management',
  '/payment-transactions/dues/:dueId': 'Due Details',
  '/payment-transactions/transactions': 'Transactions',
  
  // Super Admin Payments & Transactions
  '/super-admin-payments': 'Payments & Transactions',
  
  // Fixtures (Legacy)
  '/fixtures': 'Manage Tournaments',
  '/fixtures/add': 'Add Fixture',
  '/fixtures/:id': 'Fixture Details',
  '/fixtures/:id/edit': 'Edit Fixture',
  '/fixtures/:fixtureId/add-group': 'Add Group',
  '/fixtures/:fixtureId/groups/:groupId': 'Group Details',
  '/fixtures/:fixtureId/add-fixtures': 'Add Fixtures',
  
  // Manage Tournaments Fixtures (New)
  '/manage-tournaments-fixtures': 'Manage Tournaments',
  '/manage-tournaments-fixtures/add': 'Add Fixture',
  '/manage-tournaments-fixtures/:id': 'Fixture Details',
  '/manage-tournaments-fixtures/:id/edit': 'Edit Fixture',
  '/manage-tournaments-fixtures/:fixtureId/add-group': 'Add Group',
  '/manage-tournaments-fixtures/:fixtureId/groups/:groupId': 'Group Details',
  '/manage-tournaments-fixtures/:fixtureId/add-fixtures': 'Add Fixtures',
  
  // Access Management
  '/access-management/users': 'Users',
  '/access-management/roles': 'Roles',
  '/access-management/permissions': 'Permissions',
  '/audit-logs': 'Audit Logs',
  
  // Community
  '/community': 'Community',
  '/community/action': 'Action',
  '/community/level_up': 'Level Up',
  '/community/social': 'Social',
  '/community/:category/:videoId': 'Video Details',
  
  // Feature Management
  '/feature-management': 'Feature Management',
  '/feature-management/features': 'Features',
  '/feature-management/features/:name': 'Feature Details',
  '/feature-management/feature-toggles': 'Feature Toggles',
  '/feature-management/feature-toggles/:id': 'Feature Toggle Details',
  
  // Error Pages
  '/auth-404': 'Page Not Found',
  '/auth-500': 'Server Error',
  '/auth-503': 'Service Unavailable',
  '/auth-offline': 'Offline',
};

export const getPageTitle = (pathname: string): string => {
  try {
    // Remove query parameters
    const cleanPath = pathname.split('?')[0];
    
    // Try exact match first
    if (PAGE_TITLES[cleanPath]) {
      return PAGE_TITLES[cleanPath];
    }
    
    // Try pattern matching for dynamic routes
    for (const [pattern, title] of Object.entries(PAGE_TITLES)) {
      if (pattern.includes(':')) {
        const regexPattern = pattern
          .replace(/:[^/]+/g, '[^/]+') // Replace :param with regex
          .replace(/\//g, '\\/'); // Escape forward slashes
        
        const regex = new RegExp(`^${regexPattern}$`);
        if (regex.test(cleanPath)) {
          return title;
        }
      }
    }
    
    // Default title
    return 'Dashboard';
  } catch (error) {
    console.error('Error in getPageTitle:', error);
    return 'Dashboard';
  }
}; 